module.exports = __webpack_public_path__ + "img/JpModel.18615773.jpg";